/*@ngInject*/
const ProductTemplateBrowserActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function (productTemplateId) {
        var id = _.isNil(productTemplateId)?null:productTemplateId,
            url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.underwriting.product.ProductTemplate:'+id
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('productTemplateBrowserActionRepository', ProductTemplateBrowserActionRepository);
